import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CallLog} from '../call-log.service';
import {Observable} from 'rxjs/Observable';
import * as _ from 'lodash';
import * as moment from 'moment';
import {PhoneNumber} from '../phone-number.service';
import {isNullOrUndefined} from 'util';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Component({
  selector: 'app-call-history',
  templateUrl: './call-history.component.html',
  styleUrls: ['./call-history.component.css']
})

export class CallHistoryComponent implements OnInit {

  DURATION_REGEX = /PT?(\d+H)?(\d+M)?(\d+S)?/g

  @Input() callsByUsername: Observable<Array<CallLog>>;

  @Input() initialEntries = 5;

  @Output() askForCall = new EventEmitter<string>();

  maxEntries = new BehaviorSubject<number>(5);

  callHistories: Array<CallHistory[]>;
  maxCallHistories: number;

  entryState = new Map<string, boolean>();

  constructor() {
    moment.locale('pt-br');
  }

  ngOnInit() {
    this.maxEntries.next(this.initialEntries);
    Observable.combineLatest(this.maxEntries, this.callsByUsername)
      .subscribe(([maxEntries, callLogs]) => {
        const processedCalls = this.extractCallHistory(callLogs);
        [this.callHistories, this.maxCallHistories] = this.groupCallHistory(processedCalls, maxEntries);
      });
  }

  groupCallHistory(callHistories: CallHistory[], maxEntries: number): [Array<CallHistory[]>, number] {
    let maxResults = 0;
    const result = _(callHistories)
      .groupBy((callHistory: CallHistory) => callHistory.destination)
      .map((value, key) => value)
      .orderBy((values: CallHistory[]) => values[0].date)
      .reverse()
      .tap(chs => maxResults = chs.length)
      .take(maxEntries)
      .value();
    return [result, maxResults]
  }

  extractCallHistory(callLogs: Array<CallLog>): Array<CallHistory> {
    const result = _(callLogs)
      .groupBy((c: CallLog) => c.linkedId)
      .map((calls: CallLog[], linkedId) => {
        const orderedCalls = _(calls).orderBy((callLog: CallLog) => callLog.uniqueId).value();
        return new CallHistory(orderedCalls[0].sourceNumber, orderedCalls[0].sourceNumber.getLDFormat(),
          orderedCalls[0].destinationNumber.getLDFormat(), new Date(orderedCalls[0].start +
            ((new Date()).getTimezoneOffset()) * 60 * 1000), orderedCalls[orderedCalls.length - 1].conversationTime,
          CallHistoryType.OUTGOING, orderedCalls[0].linkedId);
      })
      .value();
    return result;
  }

  incrementMaxEntries() {
    this.maxEntries.next(this.maxEntries.value + this.initialEntries);
  }

  toggleDetails(id: string, event: Event) {
    console.log(`toggle detailing in ${id} - ${event}`);
    if (isNullOrUndefined(this.entryState.get(id))) {
      this.entryState.set(id, true);
    } else {
      this.entryState.delete(id);
    }
    event.stopPropagation();
  }

  isCollapsed(id: string): boolean {
    if (isNullOrUndefined(this.entryState.get(id))) {
      return true;
    } else {
      return false;
    }
  }
}

export class CallHistory {
  constructor(public destinationPhoneNumber: PhoneNumber, public destination: string, public source: string,
              public date: Date, public duration: number, public callType: CallHistoryType, public id: string) {
  }

  getPrettyNumber(): String {
    if (!isNullOrUndefined(this.destinationPhoneNumber)) {
      return this.destinationPhoneNumber.getPrettyLDFormat();
    } else {
      return this.destination;
    }
  }

  getTimeAgo(): String {
    return moment(this.date).fromNow();
  }

  convertDuration(): string {
    if (this.duration <= 0) {
      return '0s';
    }
    const converted = moment.duration(this.duration * 1000);
    return converted.humanize();
  }

}

export enum CallHistoryType {
  INCOMMING,
  OUTGOING
}





// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/call-history/call-history.component.ts